import './_policyAndTerms.scss'
import { useEffect } from "react";
import { policyContent } from '../../../content/policy.js';

const Policy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='centralBlock'>
      <p className='firstTitle'>{policyContent.title}</p>
      
      {policyContent.sections.map((section, idx) => (
        <div key={idx}>
          <p className='title'>{section.title}</p>
          {section.paragraphs.map((paragraph, pIdx) => (
            <p className='text' key={pIdx}>{paragraph}</p>
          ))}
        </div>
      ))}

      <table className="data-table">
        <thead>
          <tr>
            <th className='title'>Category</th>
            <th className='title'>Examples</th>
            <th className='title'>Collected</th>
          </tr>
        </thead>
        <tbody>
          {policyContent.tableData.map((row, idx) => (
            <tr key={idx}>
              <td className='textTable'>{row.category}</td>
              <td className='textTable'>{row.examples}</td>
              <td className='textTable'>{row.collected}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default Policy
